export class LocalStorageConstants {
    public static ID = 'Id';
    public static TOKEN = 'token';
    public static TOKEN_REQUIRED = 'TokenRequired';
    public static CURRENT_USER = 'currentUser';
    public static USER_TYPE_DESCRIPTION = 'UserTypeDescription';
    public static CLIENT_ID = 'IdClient';
    public static CURRENT_LAYOUT_STYLE = 'currentLayoutStyle';
    public static MASTER_DATA = 'MasterData';
}
